import { combineReducers } from "redux";
import FunnelStepReducer from "./pages/funnel-step/reducers";

export default combineReducers({
  funnelStep: FunnelStepReducer,
});
